import { useNavigate } from 'react-router-dom';

export default function AboutSection() {
  const navigate = useNavigate();

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
            {/* Left Image */}
            <div className="w-full lg:w-1/2">
              <div className="relative w-full aspect-[4/3] rounded-3xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Warm%20and%20inviting%20workspace%20scene%20with%20an%20open%20laptop%20displaying%20a%20colorful%20spreadsheet%20on%20screen%20surrounded%20by%20fashion%20magazines%20fabric%20swatches%20and%20a%20pair%20of%20stylish%20sunglasses%2C%20a%20steaming%20cup%20of%20matcha%20latte%20on%20a%20ceramic%20coaster%2C%20sunlit%20corner%20of%20a%20modern%20apartment%20with%20trailing%20ivy%20plant%20on%20a%20floating%20shelf%2C%20soft%20morning%20light%20filtering%20through%20sheer%20white%20curtains%2C%20cozy%20creative%20entrepreneurship%20lifestyle%20photography%20with%20authentic%20lived%20in%20details&width=800&height=600&seq=about-v2-css-01&orientation=landscape"
                  alt="About CSSBuy Spreadsheet"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>

            {/* Right Content */}
            <div className="w-full lg:w-1/2">
              <span className="inline-block px-3 py-1 text-xs font-semibold text-accent-700 bg-accent-100 rounded-full mb-4 whitespace-nowrap">
                About CSSBuy Sheet
              </span>
              <h2 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-950 mb-5 leading-tight">
                Your Gateway to Smarter
                <br />
                CSSBuy Shopping
              </h2>
              <div className="space-y-4 text-sm text-foreground-600 leading-relaxed mb-8">
                <p>
                  The <strong>CSSBuy spreadsheet</strong> has become the go-to resource for thousands of savvy shoppers navigating the world of agent-based purchasing. What started as a simple community-driven list has evolved into a comprehensive database featuring verified product links, quality control photos, and real buyer feedback across every major category — from sneakers and streetwear to luxury accessories and everyday essentials.
                </p>
                <p>
                  Our platform at <strong>cssspreadsheet.monster</strong> is designed to help you quickly navigate this wealth of information. Whether you are hunting for the latest trending sneakers, comparing agent pricing, or learning how to spot a top-tier batch from a mediocre one, we organize everything into clear, accessible categories that save you hours of manual searching.
                </p>
                <p>
                  Every link in our database connects directly to <strong>kaspreadsheet.com</strong>, the most comprehensive CSSBuy spreadsheet repository available. The data is community-verified, regularly updated, and organized for maximum browsing efficiency. No more digging through endless forum threads or outdated Google Sheets — everything you need is right here, neatly categorized and ready to explore.
                </p>
              </div>
              <button
                onClick={() => {
                  navigate('/cssbuy-spreadsheet-guide');
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-3 text-sm font-semibold text-foreground-950 bg-background-50 hover:bg-background-200 border border-background-300 rounded-full transition-colors cursor-pointer whitespace-nowrap"
              >
                Learn More About CSSBuy Sheet
                <i className="ri-arrow-right-up-line"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}